import React from "react";
import { Check } from "react-feather";

export interface RiskReversalCard {
	title: string;
	iconColor: string;
}

interface RiskReversalProps {
	title?: string;
	bgColor?: string;
	cards?: RiskReversalCard[];
}

export const defaultCards: RiskReversalCard[] = [
	{
		title: "We show up. Every day. <br /> No ghosting, no dropped balls.",
		iconColor: "border-green text-green",
	},
	{
		title: "All code is peer-reviewed and QA'd.",
		iconColor: "border-pink text-pink",
	},
	{
		title: "You retain full ownership. No vendor lock-in.",
		iconColor: "border-yellow text-yellow",
	},
];

const RiskReversal: React.FC<RiskReversalProps> = ({
	title = "We Know You've Been Burned Before",
	bgColor = "bg-white",
	cards = defaultCards,
}) => {
	return (
		<div
			className={`${bgColor} pt-[clamp(50px,10.42vw,150px)] pb-[clamp(20px,3.47vw,50px)] px-2 xl:px-0`}
		>
			<div className="riskReversalSection container mx-auto max-w-6xl px-4">
				{title && <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">{title}</h2>}

				<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
					{cards.map((card, index) => (
						<div
							key={index}
							className="bg-white p-5 rounded-xl shadow-md flex items-start gap-4"
						>
							<div
								className={`flex-shrink-0 w-12 h-12 rounded-full border-2 ${card.iconColor} flex items-center justify-center`}
							>
								<Check className="w-6 h-6" />
							</div>
							<div className="flex-1">
								<h3
									className="text-base font-bold mb-0 text-gray-900"
									dangerouslySetInnerHTML={{ __html: card.title }}
								/>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default RiskReversal;
